/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityContextDto } from './ActivityContextDto';
import {
    ActivityContextDtoFromJSON,
    ActivityContextDtoFromJSONTyped,
    ActivityContextDtoToJSON,
    ActivityContextDtoToJSONTyped,
} from './ActivityContextDto';
import type { ActivityMessageSegmentDto } from './ActivityMessageSegmentDto';
import {
    ActivityMessageSegmentDtoFromJSON,
    ActivityMessageSegmentDtoFromJSONTyped,
    ActivityMessageSegmentDtoToJSON,
    ActivityMessageSegmentDtoToJSONTyped,
} from './ActivityMessageSegmentDto';
import type { ActivityFeedEntityLinkDto } from './ActivityFeedEntityLinkDto';
import {
    ActivityFeedEntityLinkDtoFromJSON,
    ActivityFeedEntityLinkDtoFromJSONTyped,
    ActivityFeedEntityLinkDtoToJSON,
    ActivityFeedEntityLinkDtoToJSONTyped,
} from './ActivityFeedEntityLinkDto';

/**
 * Represents a single activity feed entry (historical event or action)
 * @export
 * @interface ActivityFeedEntryDto
 */
export interface ActivityFeedEntryDto {
    /**
     * Unique identifier of the activity feed entry
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    id: string;
    /**
     * Identifiant du risque assure (dossier). ABSENT du JSON (pas null) pour les entrees hors dossier — note posee sur une fiche client, note libre. Dans ce cas la navigation passe par segments/entities (Note, Personne).
     * 
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    riskId?: string | null;
    /**
     * Source of the activity entry
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    source: string;
    /**
     * Short title of the activity
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    title: string;
    /**
     * Detailed message with optional entity references.
     * Entity references use the format {EntityType:Guid} (e.g., {Personne:xxx-111})
     * which can be resolved using the entities array for navigation.
     * 
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    message: string;
    /**
     * Timestamp when the entry was created
     * @type {Date}
     * @memberof ActivityFeedEntryDto
     */
    createdAt: Date;
    /**
     * List of entity links referenced in the message
     * @type {Array<ActivityFeedEntityLinkDto>}
     * @memberof ActivityFeedEntryDto
     */
    entities: Array<ActivityFeedEntityLinkDto>;
    /**
     * Message riche (rendre a la place de message quand present)
     * @type {Array<ActivityMessageSegmentDto>}
     * @memberof ActivityFeedEntryDto
     */
    segments?: Array<ActivityMessageSegmentDto> | null;
    /**
     * Code stable pour icone/couleur/filtre : simulation | client | risque | devis | contrat | paiement | document | note | autre
     * 
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    category?: string | null;
    /**
     * Libelle pret a afficher (Simulation, Client, Risque...)
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    categoryLabel?: string | null;
    /**
     * Courtier du dossier — present UNIQUEMENT en vue Plateforme / portefeuille partage (absent du JSON sinon, pas null). La presence du champ suffit.
     * 
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    brokerId?: string | null;
    /**
     * Nom du courtier (cf. brokerId) — vue partagee uniquement
     * @type {string}
     * @memberof ActivityFeedEntryDto
     */
    brokerName?: string | null;
    /**
     * Contexte dossier (chips cliquables sous le message). Absent si le dossier a ete supprime — la presence du champ pilote l'affichage.
     * 
     * @type {ActivityContextDto}
     * @memberof ActivityFeedEntryDto
     */
    context?: ActivityContextDto | null;
}

/**
 * Check if a given object implements the ActivityFeedEntryDto interface.
 */
export function instanceOfActivityFeedEntryDto(value: object): value is ActivityFeedEntryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function ActivityFeedEntryDtoFromJSON(json: any): ActivityFeedEntryDto {
    return ActivityFeedEntryDtoFromJSONTyped(json, false);
}

export function ActivityFeedEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityFeedEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'source': json['source'],
        'title': json['title'],
        'message': json['message'],
        'createdAt': (new Date(json['createdAt'])),
        'entities': ((json['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoFromJSON)),
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ActivityMessageSegmentDtoFromJSON)),
        'category': json['category'] == null ? undefined : json['category'],
        'categoryLabel': json['categoryLabel'] == null ? undefined : json['categoryLabel'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
        'context': json['context'] == null ? undefined : ActivityContextDtoFromJSON(json['context']),
    };
}

export function ActivityFeedEntryDtoToJSON(json: any): ActivityFeedEntryDto {
    return ActivityFeedEntryDtoToJSONTyped(json, false);
}

export function ActivityFeedEntryDtoToJSONTyped(value?: ActivityFeedEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'riskId': value['riskId'],
        'source': value['source'],
        'title': value['title'],
        'message': value['message'],
        'createdAt': ((value['createdAt']).toISOString()),
        'entities': ((value['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoToJSON)),
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ActivityMessageSegmentDtoToJSON)),
        'category': value['category'],
        'categoryLabel': value['categoryLabel'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'context': ActivityContextDtoToJSON(value['context']),
    };
}

